import React from "react";
import logo from "../../../assets/logo.png";
import {BarekamIcon, IconVariants} from "../../components/icon/barekam-icon";
import BarekamText from "../../components/text";
import BarekamButton, {SimpleButtons} from "../../components/button";
import {Message, MessageSections} from "../../components/message/message";
import {
    FooterContainer,
    FooterCopyrightContainer,
    FooterInfoBlock,
    FooterInfoBlockItem,
    FooterInfoContainer
} from "../styled";
import {useLocation, useParams} from "react-router-dom";
import {useAppSelector} from "../../../redux/store";

export const DesktopFooter = () => {
    const {language} = useParams();
    const {isOpen} = useAppSelector(state => state.sidebarReducer);

    const location = useLocation();
    const path = location.pathname;

    const isInAuthPage =
        path.includes(`/${language}/login`) ||
        path.includes(`/${language}/register`) ||
        path.includes(`/${language}/change-password`) ||
        path.includes(`/${language}/account-activation`) ||
        path.includes(`/${language}/recover`)

    function onTermsClick() {
        window.open('https://barekam.am/Terms-EN.pdf', '_blank', 'rel=noopener noreferrer')
    }

    return (
        <FooterContainer style={{width: isOpen && !isInAuthPage ? 'calc(100% + 15rem)' : '100%', marginLeft: isOpen && !isInAuthPage ? '-15rem' : 'unset'}}>
            <FooterInfoContainer>
                <img src={logo} style={{height: '3.3rem', filter: 'grayscale(100%)'}} alt={""}/>

                <FooterInfoBlock>
                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.location} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_address'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>

                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.phone} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_phone'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>
                </FooterInfoBlock>

                <FooterInfoBlock>
                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.email} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_email'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>

                    <FooterInfoBlockItem>
                        <BarekamIcon variant={IconVariants.footerGlobe} size={{width: '1rem', height: '1rem'}}/>

                        <BarekamText variant={"s"} fontWeight={400} color={'#A9A9C2'}>
                            <Message messageKey={'footer_website'} sectionId={MessageSections.MAIN}/>
                        </BarekamText>
                    </FooterInfoBlockItem>
                </FooterInfoBlock>

                <FooterInfoBlock>
                    <FooterInfoBlockItem>
                        <BarekamButton type={SimpleButtons.TERMS_AND_CONDITIONS} onClick={() => onTermsClick()}>
                            <BarekamText variant={'s'} style={{textDecoration: 'underline'}} opaque>
                                <Message messageKey={'terms_and_conditions'} sectionId={MessageSections.MAIN}/>
                            </BarekamText>
                        </BarekamButton>
                    </FooterInfoBlockItem>

                    <FooterInfoBlockItem>
                        <BarekamText variant={"s"}>
                            {' '}
                        </BarekamText>
                    </FooterInfoBlockItem>
                </FooterInfoBlock>
            </FooterInfoContainer>

            <FooterCopyrightContainer>
                <BarekamText variant={'s'} color={'#A9A9C2'} width={'unset'} fontWeight={400}>
                    <Message messageKey={'footer_copyright'} sectionId={MessageSections.MAIN}/>
                </BarekamText>
            </FooterCopyrightContainer>
        </FooterContainer>
    )
}